import { withTranslation } from "react-i18next";
import SupplierInfoDetail from './SupplierInfoDetail';

export default withTranslation()(SupplierInfoDetail);